export const PRODOTTI_ACTIONS_TYPES={
    SET_CATEGORIE:"SET_CATEGORIE",
    SET_OFFERTE_BY_CATEGORIA:"SET_OFFERTE_BY_CATEGORIA",
    SET_PRODOTTI_BY_CATEGORIA: "SET_PRODOTTI_BY_CATEGORIA",
  PRODOTTI_LOADING: "PRODOTTI_LOADING",

   
}